import { render } from "./Variant_VariantClassification.vue?vue&type=template&id=3a3ef860"
import script from "./Variant_VariantClassification.vue?vue&type=script&lang=js"
export * from "./Variant_VariantClassification.vue?vue&type=script&lang=js"

import "./Variant_VariantClassification.vue?vue&type=style&index=0&id=3a3ef860&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__